import { FC, ReactNode } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

type CheckboxProps = {
  color?: string; // any bootstrap theme color
  outline?: boolean;
  error?: string | null;
  className?: string;
  name?: string;
  value?: boolean;
  label?: ReactNode | string;
  labelClassName?: string;
  disabled?: boolean;
  dataCy?: string;
  checkMarkClassName?: string;
  isIndeterminate?: boolean;
  style?: React.CSSProperties;
  circled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
};

const Checkbox: FC<CheckboxProps> = ({
  color = 'blue',
  outline,
  error,
  className,
  name,
  value,
  onChange,
  label,
  labelClassName,
  disabled,
  dataCy,
  isIndeterminate,
  checkMarkClassName,
  style,
  circled
}) => (
  <FormGroup
    noMargin
    className={`input-wrapper form-group justify-content-center ${error ? ' has-error' : ''}${
      className ? ` ${className}` : ''
    }`}
    style={style}
  >
    <FormGroup check className={`${circled ? 'circled' : ''}`}>
      <Label className={disabled ? 'disabled' : ''} check>
        <Input
          name={name}
          type="checkbox"
          checked={value}
          dataCy={dataCy}
          onChange={disabled ? () => null : onChange}
        />
        <span className={`checkbox-label fw-normal ${labelClassName}`}>{label}</span>

        <span
          className={`checkmark checkmark__${color} ${
            outline ? `outlined outlined__${color}` : ''
          } ${checkMarkClassName || ''} ${isIndeterminate ? 'checkmark--indeterminate' : ''}`}
        />
      </Label>
    </FormGroup>
  </FormGroup>
);

export default Checkbox;
